import { useFeature, useLoadableFeature } from '@hackler/react-sdk';

export const MY_NOTE_FEATURE = 106;

export const useMyNoteFeature = () => {
  const isFeatureOn = useFeature(MY_NOTE_FEATURE);

  return { isFeatureOn };
};

export const MY_POST_FEATURE = 107;

export const MY_ORDER_FEATURE = 108;

export const MY_LIKES_FEATURE = 109;

export const MY_COURSES_FEATURE = 115;

export const HUB_PROFILE_FEATURE = 133;

export const CHALLENGE_PHASE_2_FEATURE_KEY = 191;

export const GIFT_FEATURE = 195;

export const useMyCoursesFeature = () => {
  const isFeatureOn = useFeature(MY_COURSES_FEATURE);

  return { isMyCoursesFeatureOn: isFeatureOn };
};

export const useHubProfileFeature = () => {
  const isFeatureOn = useFeature(HUB_PROFILE_FEATURE);

  return { isHubProfileFeatureOn: isFeatureOn };
};

export const MENTORING_FEATURE = 183;

export const useMentoringFeature = () => {
  const isFeatureOn = useFeature(MENTORING_FEATURE);

  return { isMentoringFeatureOn: isFeatureOn };
};

export const useChallengePhase2Feature = () => {
  const isFeatureOn = useFeature(CHALLENGE_PHASE_2_FEATURE_KEY);

  return { isChallengePhase2FeatureOn: isFeatureOn };
};

export const MARKETING_PARTNERS_FEATURE = 200;

export const useMarketingPartnersFeature = () => {
  const { isOn: isFeatureOn, isLoading } = useLoadableFeature(MARKETING_PARTNERS_FEATURE);

  return { isMarketingPartnersFeatureOn: isFeatureOn, isLoading };
};
